<template>
  <div style="font-size: 16px; padding-top: 20px;" class="px-4 sm:px-6 lg:px-8">
    <h2>Hello, {{ firstName }}!</h2>
    <p style="opacity: 80%;">
      I’m here to help provide information on competitive intel. You can ask me questions about a competitors products and I will do my best to provide an answer!
    </p>
    <p style="margin-bottom: 10px;">
      <b>I can currently give competitor comparison information on the following:</b>
    </p>
    
    
   
    
   
    <div
      class="grid-container"
      style="display: grid; gap: 10px; margin: 20px 0;"
    >
      <div
        v-for="(item, i) in docs"
        :key="i"
        style="display: flex; flex-direction: column;"
      >
        <div
          class="box"
          style="
            flex: 1;
            width: 100%;
            justify-content: center;
            text-align: left;
            background-color: #ffffff;
            padding: 15px;
            margin: 0;
            border-radius: 8px;
          "
        >
          <p style="margin: 0; font-size: 16px; color: #333;">
            <b>{{ item.title }}</b>
          </p>
          <p style="margin: 0; font-size: 15px; color: #333; opacity: 80%;">
            {{ item.body }}
          </p>
        </div>
      </div>
    </div>
    <p style="margin-top: 0px; margin-bottom: 10px;"><b>Prompt examples:</b></p>
    <ul>
      <li>Compare Freestyle lockers to Lincora</li>
      <li>Tell me about Penco lockers</li>
      <li>Give me information on Tiffin lockers</li>
      <li>Compare Freestyle lockers to Tiffin lockers</li>
    </ul>
  
    <p style="margin-top: 30px;"><b>Disclaimer</b></p>
    <p style="opacity: 80%;">
      This application strives to provide accurate answers based on retrieved data and advanced language models. However, the accuracy of responses depends on the underlying data sources. Answers may not always be error-free, and users should verify critical information independently from the referenced documents attached to the response. We are not liable for any decisions made based on the provided responses.
    </p>
  </div>
</template>

<script>
export default {
  name: "IntelDisclaimer",
  props: {
  },
  data() {
    return {
      docs: [
        { cat: "Storage", title: "Lockers (Evidence Lockers, Freestyle)", body: "DASCO, Datum, DeBourgh, FASCO, Hallowell, Lincora, Lyon, Montel, Penco, Perfix, Spacefile, Tiffin" },
        { cat: "Storage", title: "Mobile (Manual, Mechanical Assist, Powered)", body: "Spacefile, Datum, Montel" },
        { cat: "Storage", title: "Weapons Storage (UWR)", body: "Combat Weapons Storage Systems, Datum,  Halowell,  Marvel Weapons Rack, Securelt, Tiffin" },
        // { title: "Service & Installation", body: "Installation Manuals, Owner's Manuals, Operating Instructions" },
        // { title: "Sales & Training", body: "Sales, Sustainability, Contracts" },
      ],
      prompts: [
        { body: "Compare Freestyle lockers to Lincora" },
        { body: "Tell me about Montel Powered Mobile" },
        { body: "Give me information on Tiffin lockers" },
        { body: "How does Datum manual mobile compare to Spacesaver?" },
        { body: "Compare Freestyle lockers to Tiffin lockers" },


        
      ],
    };
  },
  methods: {
    clickPrompt(prompt) {
      this.$emit('select-prompt', prompt);
    },
    
  },
  computed: {
    firstName() {
      return this.$store.state.user.FirstName;
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
/* Mobile-first: Default to 1 column for screens 991px and below */
.grid-container {
  grid-template-columns: 1fr;
}

/* Desktop: Switch to 3 columns at 992px and above */
@media screen and (min-width: 992px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
}
.click-prompt {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.click-prompt:hover {
  cursor: pointer;
  color: #000;
  text-decoration: none;
}
</style>